var CONFUSEDCMS = CONFUSEDCMS || {};
CONFUSEDCMS.VehicleDetailsValidation = CONFUSEDCMS.VehicleDetailsValidation || {};

(function (ns, $) {
    'use strict';


    ns.jQueryValidateExtensions = function () {

        //Regex Method Validator
        $.validator.addMethod(
            'regex',
            function (value, element, regexp) {
                var re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            },
            'Please check your input.'
        );

        $.validator.addMethod(
            'notdefault',
            function (value, element, param) {
                var $element = jQuery(element);

                if ($element.is('[type=checkbox]')) {
                    return $element.is(':checked');
                }

                if ($element.is('[type=radio]')) {
                    var checkBoxName = $element.attr('name');
                    return $('[name=' + checkBoxName + ']').is(':checked');
                }

                if (value === param) {
                    return false;
                }

                return true;
            },
            'Please check your input.'
        );

    };

    ns.vehicleDetailsCheckerRules = function () {

        function addRule(validator, $form, validationRule) {
            var $elem = $form.find(validationRule.selector);

            if ($elem.length !== 0) {
                $elem.rules('add', validationRule.rules);
            }
        }

        var ValidationDefinition = function (selector, rules, message) {
            this.selector = selector;
            this.rules = rules;
            this.message = message;
        };


        function hookupForm($form, validators, options) {
            if (!$form) {
                throw '$form is undefined!';
            }

            //exit early if form isn't found
            if ($form.length === 0) {
                return;
            }
            options = options || {};

            var validator = $form.validate(options);

            for (var i = 0; i < validators.length; i++) {
                var validationRule = validators[i];
                addRule(validator, $form, validationRule);
            }
        }

        var validationRules = {
           
            VehicleReg: new ValidationDefinition('input#regNumber', {
                notdefault: '',
                regex: '^[a-zA-Z0-9 -]{2,10}$',
                messages: {
                    notdefault: 'Please enter a vehicle registration number',
                    regex: 'Please enter a valid vehicle registration number'
                }
            })
        };

        return {
            hookup: hookupForm,
            validationRules: validationRules
        };

    };

    CONFUSEDCMS.setUpVehicleDetailsCheckerValidation = function ($form) {
        ns.jQueryValidateExtensions();


        var vehicleDetailsCheckerRules = ns.vehicleDetailsCheckerRules();
        vehicleDetailsCheckerRules.hookup($form, [
            vehicleDetailsCheckerRules.validationRules.VehicleReg
        ],
        {
            errorElement: 'div',
            errorClass: 'error-message',
            errorPlacement: function (error) {
                $('div#error-placement').first().append(error);
            },
            onfocusout: function (element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            },
            onblur: function (element) {
                if ((!$(element).hasClass('ignore')) && $(element).hasClass('notdefault') || (!this.checkable(element) && (element.name in this.submitted || !this.optional(element)))) {
                    this.element(element);
                }
            },

            highlight: function () {
            },

            unhighlight: function () {
            },

            ignore: ':not(\'input#regNumber\')'
        });
    };


}(CONFUSEDCMS.VehicleDetailsValidation, jQuery));